<span #container class="body-01 text"> {{ text }} </span>
